<template>
  <div
    class="w-full h-auto p-5 bg-white rounded-xl border border-slate-200 flex flex-col gap-4"
  >
    <div class="w-full h-auto bg-white rounded-lg shadow dark:bg-gray-800 p-4 md:p-6">
      <div class="self-stretch flex justify-between items-center mb-4">
        <div class="grow shrink basis-0 h-5 flex items-center">
          <div
            class="grow shrink basis-0 h-5 text-neutral-900 text-lg font-semibold font-['Public Sans'] leading-7"
          >
            Cost By Project
          </div>
        </div>
      </div>
      <div>
        <apexchart
          type="donut"
          :height="isMobileView ? undefined : 350"
          :options="chartDonutOptions"
          :series="seriesDonut"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import ApexCharts from "vue3-apexcharts";

export default {
  components: {
    apexchart: ApexCharts,
  },
  setup() {
    const store = useStore();
    const isMobileView = computed(() => store.getters.isMobileView);

    const seriesDonut = ref([]);
    const chartDonutOptions = ref({
      chart: {
        type: "donut",
      },
      labels: [],
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 90,
          offsetY: 10,
        },
      },
      grid: {
        padding: {
          bottom: -80,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    });

    onMounted(async () => {
      try {
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await store.dispatch("fetchApprovedOutgoings", {
          timezone: userTimezone,
          weekOffset: 0,
        });

        if (response && response.ok && response.data) {
          const labels = Object.keys(response.data);
          const values = Object.values(response.data).map(parseFloat);
          seriesDonut.value = values;
          // Reasignar options para que apexcharts tome los nuevos labels
          chartDonutOptions.value = { ...chartDonutOptions.value, labels };
        } else {
          console.warn("No approved outgoings data available.");
        }
      } catch (error) {
        console.error("Error fetching cost by project:", error);
      }
    });

    return { seriesDonut, chartDonutOptions, isMobileView };
  },
};
</script>
